import React from "react";
import { Link } from "react-router-dom";
import "../CSS/RecentPosts.css";
import { BLOG_KEYWORDS } from "./BlogPost";

const RecentPosts = ({ posts, currentSlug }) => {
  // ✅ SAFETY GUARD (prevents mobile crash)
  if (!posts || typeof posts !== "object") return null;

  const entries = Object.entries(posts);
  if (!entries.length) return null;

  const currentEntry = entries.find(([slug]) => slug === currentSlug);
  if (!currentEntry) return null;

  const currentOrder = currentEntry[1].order;


  // current blog + previous 4
  const orderedPosts = entries
    .filter(([, post]) => post.order <= currentOrder)
    .sort(([, a], [, b]) => b.order - a.order)
    .slice(0, 5);

  return (
    <aside className="recent-posts">

      {/* 🔹 Recent Posts */}
      <h3 className="recent-posts-title">Recent Posts</h3>

      <div className="recent-posts-list">
        {orderedPosts.map(([slug, post]) => (
          <Link
            key={slug}
            to={`/blog/${slug}`}
            className={`recent-post-item ${
              slug === currentSlug ? "active-post" : ""
            }`}
          >
            <img src={post.image} alt={post.title} />
            <div className="recent-post-text">
              <p className="recent-post-title">{post.title}</p>
              <span className="recent-post-date">{post.date}</span>
            </div>
          </Link>
        ))}
      </div>

      {/* 🔹 Keywords */}
      <h3 className="recent-posts-title keywords-title">Keywords</h3>

      <div className="keywords-wrapper">
        {BLOG_KEYWORDS.map((key, index) => (
          <span key={index} className="keyword-tag">
            {key}
          </span>
        ))}
      </div>

    </aside>
  );
};

export default RecentPosts;
